import React from "react";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
}));

interface FullWidthTextFieldWithSuffixIconProps {
  label: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  icon: React.ReactNode;
  onIconClick?: () => void;
}

export const FullWidthTextFieldWithSuffixIcon = (
  props: FullWidthTextFieldWithSuffixIconProps
) => {
  const classes = useStyles();
  const { label, value, onChange, icon, onIconClick } = props;

  return (
    <FormControl fullWidth className={classes.margin} variant="outlined">
      <TextField
        className={classes.margin}
        variant="outlined"
        label={label}
        size="small"
        id="full-width-text-field-with-suffix-icon"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                onClick={onIconClick ? onIconClick : () => {}}
              >
                {icon}
              </IconButton>
            </InputAdornment>
          ),
        }}
        onChange={onChange}
        value={value}
      />
    </FormControl>
  );
};
